import { render, staticRenderFns } from "./LiteraturePortal.vue?vue&type=template&id=3fe53532&scoped=true&"
import script from "./LiteraturePortal.vue?vue&type=script&lang=js&"
export * from "./LiteraturePortal.vue?vue&type=script&lang=js&"
import style0 from "./LiteraturePortal.vue?vue&type=style&index=0&id=3fe53532&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe53532",
  null
  
)

export default component.exports